export default __webpack_public_path__ + "static/media/ods12.d0071534.svg";